import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { NavService } from '../nav.service';
import { NavOverlayService } from './nav-overlay.service';

@Component({
  selector: 'app-nav-overlay',
  templateUrl: './nav-overlay.component.html',
  styleUrls: ['./nav-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, I18nPipe],
})
export class NavOverlayComponent {
  constructor(
    public nav: NavService,
    private _router: Router,
    private _navOverlay: NavOverlayService,
  ) {}

  public route(route: string[]): void {
    this._router.navigate(route);
    this._navOverlay.close();
  }
}
